import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { en_US_translations_fallback } from '@util/i18n/en_US'

export const initI18n = () => {
  // Pulls language from localstorage or gets from browser
  const userLang =
    localStorage.getItem('ThriveWebApp_SelectedLanguage') ||
    navigator.language ||
    'en_fb'

  const getInitialLanguageBundles = () => {
    const storedTranslations = localStorage.getItem('ThriveWebApp_Translations')
    if (storedTranslations) {
      return {
        ...JSON.parse(storedTranslations),
        en_fb: { translation: en_US_translations_fallback },
      }
    } else {
      return {
        en_fb: { translation: en_US_translations_fallback },
      }
    }
  }

  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources: getInitialLanguageBundles(),
      debug: true,
      lng: userLang,
      fallbackLng: 'en_fb',
      saveMissing: true,
      interpolation: {
        escapeValue: false,
      },
    })
}

export const languages = [
  { label: 'English', value: 'en' },
  { label: 'French', value: 'fr' },
  { label: 'Spanish (Latin America)', value: 'es' },
  { label: 'Simplified Chinese', value: 'zh_Hans' },
  { label: 'Italian', value: 'it' },
  { label: 'German', value: 'de' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Portuguese (Brazil)', value: 'pt_Br' },
  { label: 'Romanian', value: 'ro' },
  { label: 'French Canadian', value: 'vi' },
]
/**
 * Small util tool to format from api to i18n
 * @param languageCode
 */
export const languageApiFormatterUtil = (languageCode: string): string => {
  let language = ''
  switch (languageCode) {
    case 'zh_Hans':
      language = 'zh-hans'
      break
    case 'pt_Br':
      language = 'pt-br'
      break
    default:
      language = languageCode
      break
  }
  return language
}
